import { FC, memo, useMemo } from 'react'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { Tab, Tabs } from 'src/components/molecules'

import { useAuthority } from 'src/hooks'
import { Routes } from 'src/routes'

type ProjectPageTabType = 'projects' | 'commonContents' | 'analytics' | 'dataConnect'

type Props = {
  className?: string
}

export const ProjectPageTabs: FC<Props> = memo(({ className }) => {
  const pathname = usePathname()
  const { canReadCommonContent, canReadReport, canOptOutCustomer, canDeleteCustomer } =
    useAuthority()

  const selected: ProjectPageTabType = useMemo(() => {
    return pathname.startsWith(Routes.ProjectCommonContents.path)
      ? 'commonContents'
      : pathname.startsWith(Routes.ProjectAnalytics.path)
      ? 'analytics'
      : pathname.startsWith(Routes.ProjectDataConnect.path)
      ? 'dataConnect'
      : 'projects'
  }, [pathname])

  return (
    <div className={className}>
      <Tabs size="m" className="tw-ml-10">
        <Link href={Routes.ProjectTop.path} className="tw-h-full">
          <Tab
            size="m"
            isSelected={selected === 'projects'}
            text="一覧"
            className="tw-z-10 tw-h-full"
          />
        </Link>
        {canReadCommonContent && (
          <Link href={Routes.ProjectCommonContents.path} className="tw-h-full">
            <Tab
              size="m"
              isSelected={selected === 'commonContents'}
              text="共通コンテンツ"
              className="tw-z-10 tw-h-full"
            />
          </Link>
        )}
        {canReadReport && (
          <Link href={Routes.ProjectAnalytics.path} className="tw-h-full">
            <Tab
              size="m"
              isSelected={selected === 'analytics'}
              text="分析"
              className="tw-z-10 tw-h-full"
            />
          </Link>
        )}
        {(canOptOutCustomer || canDeleteCustomer) && (
          <Link href={Routes.ProjectDataConnect.path} className="tw-h-full">
            <Tab
              size="m"
              isSelected={selected === 'dataConnect'}
              text="データ管理"
              className="tw-z-10 tw-h-full"
            />
          </Link>
        )}
      </Tabs>
    </div>
  )
})
